import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import UserService from "services/user.service"

const service = new UserService()

export const fetchData = createAsyncThunk("report/fetchData", async () => {
  const resp = await service.getDealerReports()
  return resp.data.data
})

const initialState = {
  data: [],
  filters: {
    cpa: 2.5,
    transferRate: 0.1,
    campaignStatus: "Active",
    cpt: 30.0,
  },
}

const dealerReportReducer = createSlice({
  name: "reportFilters",
  initialState,
  reducers: {
    setFilters: (state, action) => {

      return { ...state,  filters: action.payload }
    },
    clearFilters: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = action.payload
    })
  },
})

export const { setFilters, clearFilters } = dealerReportReducer.actions

export default dealerReportReducer.reducer
